import { createReducer, on } from '@ngrx/store';

import {
	getDetailsForConnectedUser,
	getDetailsForConnectedUserSuccess,
	setCurrentOrganization,
} from './app.actions';
import { CoreState } from './app.state';

export const coreReducer = createReducer<CoreState>(
	new CoreState(),
	on(getDetailsForConnectedUser, (state, action) =>
		state.setCurrentUser(action.user),
	),
	on(getDetailsForConnectedUserSuccess, (state, action) =>
		state
			.setCurrentUser(
				state.currentUser
					.setAvailableInstanceModules(action.instanceModules)
					.setPreferences(action.preferences),
			)
			.setOrganizationsForUser(action.organizationPerUserAccount)
			.setSelectedOrganization(action.defaultOrganizationId)
			.setFeatures(action.features),
	),
	// triggers on redirect and if user navigates on one of its org account
	on(setCurrentOrganization, (state, action) =>
		state.setSelectedOrganization(action.orgId),
	),
);
